import React from 'react';
import { motion } from 'framer-motion';
import { Book, Cake, Coffee, Heart, Music2, Users } from 'lucide-react';

export function BBBHighlights() {
  const highlights = [
    {
      icon: Book,
      title: "Bible Study",
      description: "Engage the Word with interactive sessions."
    },
    {
      icon: Coffee,
      title: "Brunch",
      description: "Savor good food and great company."
    },
    {
      icon: Cake,
      title: "Laughter",
      description: "Celebrate life with joy and laughter."
    },
    // {
    //   icon: Users,
    //   title: "Community",
    //   description: "Grow together with fellow believers."
    // }
  ];

  return (
    <div className=" bg-gray-900">
      <div className="container max-w-7xl mx-auto px-4">
        <div className="grid grid-cols-3 md:grid-cols-3 lg:grid-cols-3 gap-2 md:gap-8">
          {highlights.map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              className="bg-black/90 backdrop-blur-sm rounded-2xl p-6 border border-pink-300/10 hover:border-pink-300/20 transition-all duration-300"
            >
              <div className="grid grid-cols-1 lg:grid-cols-6 md:flex md:items-center" >
                <div className="w-12 h-12 bg-pink-500/10 rounded-xl flex items-center justify-center mb-4">
                  <item.icon className="w-6 h-6 text-pink-300" />
                </div>
                <h3 className="text-sm md:text-xl font-semibold mb-2 md:pl-2">{item.title}</h3>
              </div>
              <p className="text-xs md:text-md text-gray-400">{item.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
}